import { atom } from 'jotai';

export const selectedGeneralLedgerActionState = atom<'upload' | null>(null);
